import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  destroyAccount,
  getDestroyStatus,
  getDevices,
  getAccountPII,
  deleteShare,
  getAccountPIIStatus
} from "./DeleteAccountActions";
import Grid from "@material-ui/core/es/Grid";
import common from "@material-ui/core/colors/common";
import red from "@material-ui/core/colors/red";

const white = common.white;
const red500 = red["500"];
import { changePageHeader } from "../app/AppActions";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Paper from "@material-ui/core/es/Paper";
import Button from "@material-ui/core/es/Button";
import { openConfirmationModal } from "../../components/confirmation-modal/ConfirmationModalActions";
import Grow from "@material-ui/core/es/Grow";
import {FaCheck, FaWindowClose} from "react-icons/fa";
import CircularProgress from "@material-ui/core/es/CircularProgress";
import UploadsInfoTable from "./components/UploadsInfoTable";
import DaInfoTable from "./components/DaInfoTable";
import UserInfoTable from "./components/UserInfoTable";
import RtscInfo from "./components/RtscInfo";
import Typography from "@material-ui/core/es/Typography";
import Dialog from "@material-ui/core/es/Dialog";
import DialogActions from "@material-ui/core/es/DialogActions";
import DialogContent from "@material-ui/core/es/DialogContent";
import { DialogTitle } from "@material-ui/core/es";
const env = process.env.NODE_ENV;

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  componentWillMount() {
    const { changePageHeader, getAccountPIIStatus, user, brand } = this.props;
    changePageHeader("Delete Account");
    getAccountPIIStatus(user.email, brand.id);
  }

  componentWillReceiveProps(nextProps) {
    // const {user, brand, account, getDestroyStatus, getAccountPII} = nextProps;
    // if (!account.fetchingPii && !account.pii.hasOwnProperty("index") && brand.id && user.email) {
    //     getAccountPII(user.email, brand.id)
    // }
    //     if(!nextProps.account.fetching && nextProps.account.destroy.status && nextProps.account.destroy.status==='REQUESTED') {
    //         setTimeout(() => getDestroyStatus(user.email, brand.id), 1000)
    //     }
  }

  openConfirmationModal = () => {
    const { user, brand, destroyAccount } = this.props;
    this.handleClose();
    this.props.openConfirmationModal({
      text: "Are you sure you want to delete this account?",
      callback: () => destroyAccount(user.email, brand.id),
      confirmCheckbox: true
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpen = () => {
    this.setState({ open: true });
  };

  renderDestroyStatusIcon(status) {
    switch (status) {
      case "REQUESTED":
        return <CircularProgress size={15} />;
      case "FAILED":
        return <FaWindowClose color={"red"} />;
      default:
        return <FaCheck color={"green"} />;
    }
  }

  getDateFormated(time) {
    const date = new Date(time);
    return date.toLocaleString();
  }

  render() {
    const {
      classes,
      user,
      brand,
      account,
      getDestroyStatus,
      getAccountPII
    } = this.props;

    let { open } = this.state;

    console.log(this.props);
    return (
      <div>
        {!account.fetchingPiiStatus && account.piiStatus ? (
          <div>
            <Grid container justify="center">
              <Grid xs={11} sm={9} md={7} item>
                <Typography
                  gutterBottom
                  variant="headline"
                  className={classes.serviceHeadLine}
                >
                  {`How to Permanently Delete Your Account and All Information From ${brand.name} Cloud`}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="center"
              className={classes.serviceContent}
              spacing={24}
            >
              <Grid xs={11} sm={9} md={7} item>
                <Typography
                  component="p"
                  className={classes.serviceContentText}
                >
                  {`Permanently deleting your account, removes your account details from ${brand.name} cloud. After this is complete, you will no longer have access to your account on ${brand.name} and all traces of your account will be removed instantly as we do not store your emails on our servers.

If you would like to permanently delete your account, please do the following:
1. Remove your account from the ${brand.name} app on `}
                  <strong style={{ fontWeight: 800 }}>all</strong>
                  {` of your devices.`}
                  <li style={{ paddingLeft: "1.5rem" }}>
                    You can remove your account within the app by tapping More
                    (o o o) | Various Account Settings | Tap the account you
                    wish to delete | Edit Account | Remove Account | Confirm
                    with OK
                  </li>
                  {`2. Click the “Delete Account” button below and wait for confirmation.

Please Note: You will need to do the steps above for every account you wish to delete on ${brand.name}. This is a permanent action and cannot be undone.`}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify="center" className={classes.serviceContent}>
              <Grid item xs={12} sm={6} lg={4}>
                {/* <Paper className={classes.pageContainer}> */}
                <Grid container justify="center">
                  <Grid item>
                    <Button
                      style={{marginRight: '10px'}}
                      variant="raised"
                      color="secondary"
                      onClick={this.handleOpen}
                    >
                      Delete Account
                    </Button>
                  </Grid>
                  {(env === "development" || env === "staging") && (
                    <Grid item>
                      <Button
                        variant="raised"
                        color="primary"
                        onClick={() => getDestroyStatus(user.email)}
                      >
                        Get Delete Status
                      </Button>
                    </Grid>
                  )}

                  {account.destroy.detailsList && (
                    <Grid item xs={12}>
                      {account.destroy.detailsList.map((d, index) => (
                        <Grow in key={d.id} timeout={index * 700 + 500}>
                          <div>
                            {`${d.component}: `}
                            {this.renderDestroyStatusIcon(d.status)}
                          </div>
                        </Grow>
                      ))}
                    </Grid>
                  )}
                </Grid>
                {/* </Paper> */}
                <DaInfoTable classes={classes} />
                <UploadsInfoTable classes={classes} />
                {/*<UserInfoTable classes={classes}/>*/}
                <RtscInfo classes={classes} />
              </Grid>
            </Grid>
          </div>
        ) : (
          <div style={{ textAlign: "center", paddingTop: "30px" }}>
            <CircularProgress />
          </div>
        )}

        <Dialog open={open} onClose={this.handleClose}>
          <DialogTitle>
            Are you sure? Your data will be permanently deleted
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.openConfirmationModal} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  deleteButton: {
    backgroundColor: red500,
    color: white
  },
  pageContainer: {
    padding: 24,
    marginBottom: 40
  },
  tableWrapper: {
    overflowX: "auto"
  },
  title: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: "0.7em 0",
    fontSize: "1.5rem",
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.20588em"
  },
  accountEmail: {
    padding: ".3em 0 .7em 0",
    fontSize: "1rem",
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  loadingCircleContainer: {
    textAlign: "center",
    paddingTop: "35px"
  },
  serviceHeadLine: {
    fontSize: 24,
    paddingTop: 32,
    lineHeight: "42px"
  },
  serviceContent: {
    marginTop: 16,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0
    }
  },
  serviceContentText: {
    color: "rgba(0,0,0,0.65)",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    whiteSpace: "pre-wrap"
  },
  contactsList: {
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    paddingRight: 1,
    maxHeight: 300,
    margin: "-10px 0px 12px"
  },
  groupsList: {
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    paddingRight: 1,
    maxHeight: 600,
    margin: "12px 0px"
  },
  ultraProfile: {
    padding: 15
  },
  gridList: {
    // width: 500,
    // height: 450,
    maxHeight: 400,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)"
  },
  expPanel: {
    width: "100%",
    boxShadow: "unset"
  }
});

function mapStateToProps({ account, user, brand }) {
  return { account, user, brand };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      destroyAccount,
      changePageHeader,
      getDestroyStatus,
      getAccountPII,
      openConfirmationModal,
      deleteShare,
      getAccountPIIStatus
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Account));



// WEBPACK FOOTER //
// ./src/containers/delete-account/DeleteAccount.js